import { Box, Button, Center, Overlay, Stack, Text } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { i18nKeys, useTranslation } from 'locales';
import { useParams } from 'react-router-dom';
import { gradientBorderClass } from './AiSummaryPanel.styles';
import { useCreateDebtorAiSummary } from './hooks/use-create-debtor-ai-summary';
import type { AiSummary } from './hooks/use-load-debtor-ai-summary';

type AiSummaryOutdatedOverlayProps = {
  aiSummary: NonNullable<AiSummary>;
  setIsOutdated: (value: boolean) => void;
};

export const AiSummaryOutdatedOverlay = ({
  aiSummary,
  setIsOutdated,
}: AiSummaryOutdatedOverlayProps) => {
  const { t } = useTranslation();
  const { id: debtorId } = useParams<{ id: string }>();

  const { createDebtorAiSummary } = useCreateDebtorAiSummary();

  const handleGenerateBriefing = () => {
    createDebtorAiSummary({ debtorId });
  };

  return (
    <Overlay color="purple.5" backgroundOpacity={0.1} blur={12}>
      <Center h="100%">
        <Stack p="xl">
          <Text c="gray.10">
            {t(i18nKeys.AI_SUMMARY.OUTDATED_OVERLAY.DESCRIPTION, {
              date: dayjs(aiSummary.createdAt).format('LL'),
            })}
          </Text>
          <Stack align="center">
            <Box w="70%" className={gradientBorderClass}>
              <Button
                w="100%"
                variant="transparent"
                c="white"
                rightSection={<IconSparkles stroke={1.5} size={18} />}
                onClick={handleGenerateBriefing}
              >
                {t(i18nKeys.AI_SUMMARY.OUTDATED_OVERLAY.REGENERATE)}
              </Button>
            </Box>
            <Button w="70%" variant="light" onClick={() => setIsOutdated(false)}>
              {t(i18nKeys.AI_SUMMARY.OUTDATED_OVERLAY.UNDERSTOOD)}
            </Button>
          </Stack>
        </Stack>
      </Center>
    </Overlay>
  );
};
